import { DatePipe } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { TranslationService } from '@df/ui/translation/translation.service';

@Injectable({
    providedIn: 'root'
})
export class DeliveryEstimationService {
    private translationService = inject(TranslationService);
    private datePipe = inject(DatePipe);

    getDeliveryEstimationInfo(method: { estimated_delivery_data?: { dates: string[] }; code?: string }): string | undefined {
        if (!method.estimated_delivery_data) {
            return undefined;
        }

        if (method.code === 'tcoshippingmethodtableratescurri_DPD|Next Day 12') {
            return undefined;
        }

        if (!method.estimated_delivery_data) {
            return undefined;
        }
        if (method.estimated_delivery_data.dates?.length > 1) {
            const startDate = new Date(method.estimated_delivery_data.dates[0]);
            const endDate = new Date(method.estimated_delivery_data.dates[method.estimated_delivery_data.dates.length - 1]);
            return startDate && endDate
                ? this.translationService.transform(
                      'Between % and %, % %',
                      this.datePipe.transform(startDate, 'EEEE'),
                      this.datePipe.transform(endDate, 'EEEE'),
                      `${this.datePipe.transform(startDate, 'dd')}-${this.datePipe.transform(endDate, 'dd')}`,
                      this.datePipe.transform(endDate, 'MMM')
                  )
                : undefined;
        } else if (method.estimated_delivery_data.dates?.length === 1) {
            const deliveryDate = new Date(method.estimated_delivery_data.dates[0]);

            const dayName = this.datePipe.transform(deliveryDate, 'EEEE');
            const dateFormatted = this.datePipe.transform(deliveryDate, 'dd');
            const monthFormatted = this.datePipe.transform(deliveryDate, 'MMM');

            return this.translationService.transform(`Estimated delivery %, % %`, dayName, dateFormatted, monthFormatted);
        }
    }
}
